import React from 'react';

import {ClickEvent, Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {Button, Image} from '@udemy/react-core-components';
import {udLink} from '@udemy/ud-data';

import {Category} from 'src/features/category/types';

import styles from './subcategories-section.module.less';

interface SubcategoriesSectionProps {
    subcategories: Category[];
    jumpLinkHandler(): void;
}

export const SubcategoriesSection = ({
    subcategories,
    jumpLinkHandler,
}: SubcategoriesSectionProps) => {
    const {gettext} = useI18n();

    const onClickSubCategory = () => {
        Tracker.publishEvent(
            new ClickEvent({
                componentName: 'SubCategoryLinks',
                relatedObjectType: 'course_subcategory',
            }),
        );
    };

    return (
        <div className="section">
            <div className="section-column image-container">
                <Image
                    className="placeholder-image"
                    src={udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/learning-for-you-v3.jpg',
                    )}
                    srcSet={`${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/learning-for-you-v3.jpg',
                    )} 1x, ${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/learning-for-you-2x-v3.jpg',
                    )} 2x`}
                    width={450}
                    height={450}
                    data-purpose="section-image"
                    alt=""
                />
            </div>
            <div className="section-column">
                <h2 className="ud-heading-serif-xxl section-title" data-purpose="section-title">
                    {gettext('Skills that suit you')}
                </h2>
                <p className="ud-text-md section-text">
                    {gettext(
                        'Learn valuable, practical skills from free online video courses. ' +
                            'Explore tech essentials and keep pace with change. Become more focused and productive. ' +
                            'Top it off with courses that round out your skills and enrich your day to day.',
                    )}
                </p>
                <div data-purpose="sub-category-links" className={styles['link-tags-container']}>
                    {subcategories.map((subcategory, i) => (
                        <Button
                            key={i}
                            componentClass="a"
                            href={subcategory.url}
                            size="medium"
                            udStyle="secondary"
                            className={styles['link-tag']}
                            onClick={onClickSubCategory}
                        >
                            {subcategory.name}
                        </Button>
                    ))}
                    <Button udStyle="ghost" size="medium" onClick={jumpLinkHandler}>
                        {gettext('See more')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
